import { useInfiniteQuery } from '@tanstack/react-query';
import { hydraUiApi, shouldRetry } from '@/services/api';
import { useAuth } from '@/services/auth';

export function useCopilotHistory() {
  const auth = useAuth();

  return useInfiniteQuery({
    queryKey: ['getCopilotSessions', auth.account.id],
    initialPageParam: 1,
    queryFn: ({ pageParam, signal }) =>
      hydraUiApi.copilot.list({
        params: {
          path: { account_id: String(auth.account.id) },
          query: { page: pageParam },
        },
        signal,
      }),
    getNextPageParam: (lastPage) => {
      const { pagination } = lastPage.meta;
      const totalPages = Math.ceil(pagination.total / pagination.size);
      return pagination.page < totalPages ? pagination.page + 1 : undefined;
    },
    retry: shouldRetry,
  });
}
